import { useQuery } from '@tanstack/react-query';

import { getVersion } from '@/api/system/get-version';

import { systemKeys } from './query-keys';

export const useVersion = () =>
  useQuery({
    queryKey: systemKeys.version(),
    queryFn: getVersion,
    staleTime: 5 * 60 * 1000,
  });
